export default __webpack_public_path__ + "static/media/stand1.ccae42b9.png";